// Dependencies
require("webstrap/type");
require("webstrap/forms");
require("webstrap/buttons");
require("grid");
require("element/rich-text");
require("mailchimp-ajax");

// Styles
require("./newsletter.scss");

// JavaScript
var $ = require("jquery");
var cookiesUtils = require("cookies-utils");
var localcookie = cookiesUtils.read('localecookie');

var $sec = $('.sec-newsletter'),
    $drawer = $('.sec-newsletter__drawer'),
    $close = $('.sec-newsletter__close'),
    classe = "sec-newsletter--fixed",
    posFromTop = 0,
    drawerHeight = 0,
    winScrollPos = 0,
    winHeight = 0,
    state = "initial",
    blnShow = false; // L'ajout de "pop over" sur le site à nécessité la désaction permanente.
    //blnShow = (cookiesUtils.read("newsletter-fixed-shown") != null) ? false : true;

// If the newsletter is in the page
if ($sec.length > 0) {
    
    var lang = (localcookie == "fr-ca") ? 'fr' : 'en';
    var $formId = $("#mc-embedded-subscribe-form");
    var $formGroup = $(".form-group", $formId);

    // Form validation (setup for manual validation)
    require("forms-validation");
    $formId.validate(require("forms-validation/options/defaults.js"));

    // Si on veut l'afficher fixe lors du scroll
    if (blnShow) {

        // Closing function
        var fnClose = function () {
            state = "closed";
            $sec.removeClass(classe);

            // Remove listener
            $(window).off('resize.newsletter');
            $(window).off('load.newsletter');
            $(window).off('scroll.newsletter');
            $close.off('click.newsletter');
        };

        // On resize
        var fnOnRezise = function () {
            posFromTop = parseFloat($sec.offset().top);
            winScrollPos = parseFloat($(window).scrollTop());
            drawerHeight = parseFloat($drawer.height());
            winHeight = parseFloat($(window).height());
            $sec.css('min-height', drawerHeight + "px");
        };

        // On scroll
        var fnOnScroll = function () {
            winScrollPos = parseFloat($(window).scrollTop());
            winHeight = parseFloat($(window).height());
            console.log("scroll");
            // Open fixed newsletter after scrolling ~1/3 of the page
            if (winScrollPos >= winHeight * 0.3 && state == "initial") {
                state = "fixed";
                $sec.addClass(classe);
                cookiesUtils.create("newsletter-fixed-shown", "1", 90);
            }

            // It's closing time
            if (winScrollPos >= (posFromTop - (winHeight - drawerHeight)) && state == "fixed") {
                fnClose();
            }
        };

        // Events
        $(window).on('resize.newsletter', function () { fnOnRezise(); fnOnScroll(); });
        $(window).on('load.newsletter', fnOnRezise);
        $(window).on('scroll.newsletter', fnOnScroll);
        $close.on('click.newsletter', fnClose);
        fnOnRezise();
        fnOnScroll();
    }
}



/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/newsletter/index.js
 ** module id = 58
 ** module chunks = 0 1
 **/